<template>
<div class="container text-center">
  <div v-if="this.disponibilidad == true" class="row justify-content-md-center">
    <div class="col col-lg-4 card-body text-center" style="background-color: #F4F6F6">
      <b-overlay :show="show" opacity="0.97" variant="light" spinner-type="grow" rounded="sm" style="max-width: 320px; color: #DD3E23">
        <img src="../assets/unidad_no_disponible-naranja.png" class="img-fluid" width="270px" height="auto" alt="" />
        <h1 class="texto-nodisponible-titulo mt-3">¡UPS! LO SENTIMOS <br> ESTE VEHÍCULO ESTÁ APARTADO</h1>
        <p class="texto-nodisponible-subtitulo">Pero no te preocupes podemos ayudarte a encontrar una opción parecida.</p>
      </b-overlay>
    </div>
  </div>

  <div v-if="this.disponibilidad == false" class="row justify-content-md-center">
    <div class="col col-lg-4 card-body text-center" style="background-color: #F4F6F6">
      <div>
        <h5 class="mt-5">Precio de Contado:</h5>
        <h1 style="font-size: 50px">${{formatPrice(this.precio1)}}</h1>
      </div>
      <b-overlay :show="show" opacity="0.97" variant="light" spinner-type="grow" rounded="sm" style="max-width: 350px; color: #DD3E23">
      <div style="margin-left: 0px">
        <h2 style="font-size: 20px; color: black">Escoge tu enganche</h2>
        <p style=" color: black">¿Selecciona el pago que deseas?</p>
        <h3 style=" color: black">$ {{formatPrice(minValue)}}</h3>
        <b-input-group class="mt-4">
          <b-form-input style="background-color: #F4F6F6; border:0px;" v-model="minValue" type="range" :min="cotizar15()" :max="cotizar90()" step="1"></b-form-input>
        </b-input-group>
        <!-- <div>parametros: {{minValue}}</div>
        <div>{{ this.val }}</div> -->
        <h2 style="font-size: 20px; color: black" class="mt-3">Escoge tu mensualidad</h2>
        <p style=" color: black">Selecciona el plazo deseado</p>
          <b-row cols="2" class="text-center mb-3" v-if="this.costos == 2">
            <b-col>
              <input type="radio" v-model="selected" class="option-input radio" name="interesc" value="12"/>
              <label class="ml-1" style="font-size: 12px; color: black"> 12 Meses ${{this.calcular()}}</label>
            </b-col>
            <b-col>
              <input type="radio" v-model="selected" class="option-input radio" name="interesc" value="24"/>
              <label class="ml-1" style="font-size: 12px; color: black"> 24 Meses ${{this.calcular2()}}</label>
            </b-col>
            <b-col>
              <input type="radio" v-model="selected" class="option-input radio" name="interesc" value="36"/>
              <label class="ml-1" style="font-size: 12px; color: black"> 36 Meses ${{this.calcular3()}}</label>
            </b-col>
            <b-col>
              <input type="radio" v-model="selected" class="option-input radio" name="interesc" value="48"/>
              <label class="ml-1" style="font-size: 12px; color: black"> 48 Meses ${{this.calcular4()}}</label>
            </b-col>
            <b-col>
              <input type="radio" v-model="selected" class="option-input radio" name="interesc" value="60"/>
              <label class="ml-1" style="font-size: 12px; color: black"> 60 Meses ${{this.calcular5()}}</label>
            </b-col>
            <!-- <b-col><b-form-radio v-model="selected" name="some-radios" value="12" > <p style="font-size: 12px; color: black">12 Meses ${{this.calcular()}}</p></b-form-radio></b-col> -->
            <!-- <b-col><b-form-radio v-model="selected" name="some-radios" value="24" ><p style="font-size: 12px; color: black">24 Meses ${{this.calcular2()}}</p></b-form-radio></b-col>
            <b-col><b-form-radio v-model="selected" name="some-radios" value="36" ><p style="font-size: 12px; color: black">36 Meses ${{this.calcular3()}}</p></b-form-radio></b-col>
            <b-col><b-form-radio v-model="selected" name="some-radios" value="48" ><p style="font-size: 12px; color: black">48 Meses ${{this.calcular4()}}</p></b-form-radio></b-col>
            <b-col><b-form-radio v-model="selected" name="some-radios" value="60" ><p style="font-size: 12px; color: black">60 Meses ${{this.calcular5()}}</p></b-form-radio></b-col> -->
          </b-row>
        <b-button @click.prevent="financiamiento()" class="button_H">FINANCIAMIENTO</b-button>
      </div>
      </b-overlay>

    </div>
  </div>
</div>
</template>

<script>

export default {
  name: 'Calculadora',

    data() {
    return {


      contents: null,
      autos: [],
      photos: [],
      vin: this.$route.query.vin,
      tipo: this.$route.query.type,
      n: '',
      paso:'',
      calculo:'',
      calculo2:'',
      calculo3:'',
      calculo4:'',
      calculo5:'',
      porcentaje: '',
      selected: '12',
      minValue: '',
      precio1: '',
      show: true,
      disponibilidad: false,
      costos: 1,
      monto: '',

      };
  },

  methods: {

    //Reservas
    tokenReservas(){
      let user = {
      username: "marco.villegas@autocom.mx",
      password: "Asd12345"};

    axios.post("https://qa-reservas.autocom.mx/api/Token/login", user)
      //.post("", user) //PRO
      .then((response) => {
        this.tokenReserva = response.data.token;
              if(this.tokenReserva != null){
                sessionStorage.setItem("tokenReservas", this.tokenReserva);
                this.validaUnidad();
              }
        }).catch(error => {
          console.log(error);
        });
    },

    validaUnidad(){
         axios.get("https://qa-reservas.autocom.mx/api/VehicleReservationQis?aplicacion=Reservas", {
         headers: {
           Authorization: "Bearer " + sessionStorage.getItem("tokenReservas"),
           'Content-Type': 'application/json',
         },
         params: {vin: this.vin},})
         .then((response) => {
            this.estatusD = response.data.status;
            //console.log('Estatus',this.estatusD)
         if( this.estatusD == 'NO DISPONIBLE' ){
             this.disponibilidad = true;
             this.show = false;
         }else{
            //console.log('Cargar Información de Vehiculo');
            this.toke();
            this.tokenStock();
         };
         }).catch(error => {
          console.log(error);
        });
    },

    tokenPasarela1(){
      let user = {username: "marco.villegas@autocom.mx", password: "Asd12345"};
      axios.post("https://qa-pasarela.autocom.mx/api/Token/login", user)
      .then((response) => {
              this.tokenPasarela = response.data.token;
              sessionStorage.setItem("tokenPasarela", this.tokenPasarela);
              if(this.tokenPasarela != null){
                //console.log('Validar monto');
                this.montoUnidad();
              }
        }).catch(error => {
          console.log(error);
        });
    },
    montoUnidad(){
        //console.log('Obtener monto de la sucursal');
        axios.get("https://qa-pasarela.autocom.mx/api/Payment/DataSubsidiary", {
        headers: {
          Authorization: "Bearer " + sessionStorage.getItem("tokenPasarela"),
          'Content-Type': 'application/json',
        }, params: {dealerQisId: this.dealerQisId }})
        .then((response) => {
          this.monto = response.data.amountPayment;
          sessionStorage.setItem("montoWeb", this.monto);
          //console.log('Estatus',this.monto)
        }).catch(error => {
        console.log(error);
      });
    },

    calulaurl(){
      if (this.selected == 12) {
        this.n = this.formatPriceSemi(this.calculo);
      }

      if (this.selected == 24) {
        this.n = this.formatPriceSemi(this.calculo2);
      }

      if (this.selected == 36) {
        this.n = this.formatPriceSemi(this.calculo3);
      }

      if (this.selected == 48) {
        this.n = this.formatPriceSemi(this.calculo4);
      }

      if (this.selected == 60) {
        this.n = this.formatPriceSemi(this.calculo5);
      }

    },

    financiamiento(){
      this.calulaurl();
        sessionStorage.setItem("porcentajeFinan", this.val);
        sessionStorage.setItem("mensualidadFinan", this.selected);
        sessionStorage.setItem("cuotaMenFinan", this.minValue);
        window.top.location.href="https://www.autocomseminuevos.com/financiamiento-autocom?vin="+this.vin+"&type="+this.tipo+"&version=SEMINUEVOS&APV=SitioWeb&porcentajeFinan="+this.val+"&mensualidadFinan="+this.selected+"&cuotaMenFinan="+this.n+"&ce="+this.tipo
    },
    tokenStock(){
      let user = {
      username: "desarrolloti@autocom.mx",
      password: "Autocom2021"};

      //axios.post("https://pruebas.autocomcube.mx/api/token/login", user)
      axios.post("https://autocomcube.mx/api/token/login", user) //PRO
      .then((response) => {
        this.contents = response.data.token;
              if(this.contents != null){
                 sessionStorage.setItem("tokenStock", response.data.token);
                 this.cargarInfoVehiculo();
              }
        }).catch(error => {
          console.log(error);
        });
    },

    toke(){
       let userTk = {
       username: "payments@autocom.mx",
       //password: "B8jc8q!n"}; //qa
       password: "d#7X4jem"}; //prod
       axios.post("https://financiamiento.autocomcube.mx/api/token/login", userTk)
        .then((response) => {
          this.contents = response.data.token;
          //console.log('Token es Financiamiento--->', response.data.token)
          sessionStorage.setItem("tknFin", response.data.token);
        });
    },
    cargarInfoVehiculo(){

      if( this.$route.query.type == 'U'){
          // console.log('Seminuevo');
              //axios.get("https://pruebas.autocomcube.mx/ab/api/usedstock", { //QA
              axios.get("https://autocomcube.mx/ab/api/usedstock", { //PRO
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
              },
              params: {vin: this.vin,},
            })
            .then((response) => {
                  this.precio1 = response.data.usedstock[0].webPrice;
                  this.estatusU = response.data.usedstock.length;
                  this.dealerQisId = response.data.usedstock[0].dealerQisId;
                  if(this.precio1 != 'undefined'){
                    this.minValue = this.precio1 * 0.25;
                    this.show = false;
                    this.costos = 2;
                    this.tokenPasarela1();
                  }
            }).catch(error => {
          console.log(error);
        });
       } else if( this.$route.query.type == 'N'){
              //axios.get("https://pruebas.autocomcube.mx/ab/api/newstock", { //QA
              axios.get("https://autocomcube.mx/ab/api/newstock", { //PRO
              headers: {
                Authorization: "Bearer " + sessionStorage.getItem("tokenStock"),
                'Content-Type': 'application/json',
              },
              params: {vin: this.vin,},
            })
            .then((response) => {
                  this.precio1 = response.data.newstock[0].webPrice;
                  this.estatusU = response.data.newstock.length;
                  this.dealerQisId = response.data.newstock[0].dealerQisId;
                  if(this.precio1 != 'undefined'){
                    this.minValue = this.precio1 * 0.25;
                    this.show = false;
                    this.costos = 2;
                    this.tokenPasarela1();
                  }
            }).catch(error => {
          console.log(error);
        });
      }
    },

    formatPriceSemi(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "")
    },

    formatPrice(value) {
        let val = (value/1).toFixed(0).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    formatPriceCostos(value) {
        let val = (value/1).toFixed(2).replace('.', '.')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },

    cotizar15() {
      return  this.precio1 * 0.15;
    },

    cotizar90() {
      return this.precio1 * 0.90;
    },

     valor() {
      this.val = +(((this.minValue)*100)/this.precio1).toFixed(2);
      return this.val;
    },

    valor2(){
      if( this.valor() >= 15 && this.valor() <= 90 ){
          this.taza = 22.90;
      } return this.taza;
    },

    // valor2(){
    //   if( this.valor() >= 15 && this.valor() <= 29.99 ){
    //       this.taza = 21.99;
    //   } else if( this.valor() >= 30 && this.valor() <= 49.99 ){
    //       this.taza = 23.90;
    //   }  else if( this.valor() >= 50 && this.valor() <= 90 ){
    //       this.taza = 22.90;
    //   } return this.taza;
    // },


     valor3(){
      if( this.selected == 12){
        this.paso = this.calculo;
        console.log('Paso -->',this.paso);
      } else if( this.selected == 24){
        this.paso = this.calculo2;
      } else if( this.selected == 36){
        this.paso = this.calculo3;
      } else if( this.selected == 48){
        this.paso = this.calculo4;
      } else if( this.selected == 60){
        this.paso = this.calculo5;
      }
      return this.paso;
    },

    montof(){
      this.montf = this.precio1-this.minValue;
      return this.montf;
    },

    calcular() {
          this.formData={
          enganche:this.valor(),
          plazo:12,
          interes:this.valor2(),
          precio: this.precio1,
          monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"), 'Content-Type': 'application/json'}
      }).then((response) => { this.calculo = response.data.mensualidad;
      });
      return this.formatPrice(this.calculo)
     },

      calcular2() {
                this.formData={
                enganche:this.valor(),
                plazo:24,
                interes:this.valor2(),
                precio: this.precio1,
                monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"),
                  'Content-Type': 'application/json'}
      }).then((response) => {
        this.calculo2 = response.data.mensualidad;
        //console.log('respuesta-->',this.calculo2)
      });
      return this.formatPrice(this.calculo2)
     },

      calcular3() {
                this.formData={
                enganche:this.valor(),
                plazo:36,
                interes:this.valor2(),
                precio: this.precio1,
                monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"),
                  'Content-Type': 'application/json'}
      }).then((response) => {
        this.calculo3 = response.data.mensualidad;
        //console.log('respuesta-->',this.calculo3)
      });
      return this.formatPrice(this.calculo3)
     },

      calcular4() {
                this.formData={
                enganche:this.valor(),
                plazo:48,
                interes:this.valor2(),
                precio: this.precio1,
                monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"),
                  'Content-Type': 'application/json'}
      }).then((response) => {
        this.calculo4 = response.data.mensualidad;
        //console.log('respuesta-->',this.calculo4)
      });
      return this.formatPrice(this.calculo4)
     },

     calcular5() {
      this.formData={
                enganche:this.valor(),
                plazo:60,
                interes:this.valor2(),
                precio: this.precio1,
                monto_adicional:0}
       //axios.post('https://pruebas-financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{//QA
       axios.post('https://financiamiento.autocomcube.mx/api/financiamiento/calculadora/', this.formData,{ //prod
       headers: {'Authorization': "Bearer " +  sessionStorage.getItem("tknFin"),
                  'Content-Type': 'application/json'}
      }).then((response) => {
        this.calculo5 = response.data.mensualidad;
        //console.log('respuesta-->',this.calculo4)
      });
      return this.formatPrice(this.calculo5)
     },

  },

  created() {
    this.tokenReservas();
  }
}
</script>

<style scoped>


</style>